export enum RequisitionStatus {
  Active = 1,
  Inactive = 2,
  Deleted = 3,
  Pending = 4,
}
